import { createStore } from 'vuex';

const store = createStore({
  state: {
    loading: false
  },
  mutations: {
    setLoading(state, value) {
      state.loading = value
    }
  }
})

export default store